module.exports = __webpack_public_path__ + "img/lightbulb.beb1388d.png";